import { AiFillCamera } from 'react-icons/ai'
import { useState } from 'react'
// import axios from 'axios'

export default function Brand ({ toggleOptions }) {
  let [uploadOptions, updateUploadOptions] = useState(true)

  const handleFileUpload = e => {
    let file = e.target.files[0]
    let reader = new FileReader()
    reader.onloadend = () => {
      let ele = document.querySelector('.profileImg')
      ele.style.background = `url(${reader.result})`
      ele.style.backgroundPosition = 'center'
      ele.style.backgroundSize = 'cover'
      ele.style.backgroundRepeat = 'no-repeat'
      updateUploadOptions(false)
    }
    if (file) {
      reader.readAsDataURL(file)
    }
  }

  let nameClasses = 'text-left block w-full relative flex items-center'
  nameClasses += !toggleOptions.picture ? ' my-10' : ''

  return (
    <ul className='brand m-0 p-0 px-32 pt-24 brand flex items-center'>
      {toggleOptions.picture ? (
        <li className='block'>
          <div className='profileImg w-80 h-80 -ml-2 rounded-full my-0 mx-auto bg-gray-400 text-gray-200 font-bold flex flex-col text-xl flex justify-center items-center'>
            <label
              for='upload'
              className='text-center flex space-x-3 cursor-pointer'
              style={{ opacity: uploadOptions ? 1 : 0 }}
            >
              <span className='text-3xl'>
                <AiFillCamera />
              </span>
              <span>upload photo</span>
            </label>
            {!uploadOptions ? (
              <label
                for='upload'
                className='upld text-center justify-center flex-row items-center relative space-x-3 cursor-pointer hidden whitespace-nowrap'
              >
                <span>upload photo</span>
                {/* <span className='text-3xl'>
                  <AiFillCamera />
                </span> */}
              </label>
            ) : null}
            <span className='preview w-32 h-32 absolute top-2/4 left-2/4'></span>
            <input
              type='file'
              className='block hidden'
              id='upload'
              onChange={handleFileUpload}
            />
          </div>
        </li>
      ) : null}
      <li className={nameClasses}>
        <div className='-space-y-2'>
          <p
            contentEditable='true'
            placeholder='Your name'
            className='myColor text-8xl font-bold text-blue-500 uppercase'
          ></p>
          {toggleOptions.profession ? (
            <p
              contentEditable='true'
              placeholder='Profession'
              className='text-4xl font-bold text-gray-500 uppercase'
            ></p>
          ) : null}
        </div>
      </li>
    </ul>
  )
}
